<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div class="relative">
		<div class="vx-navbar-wrapper navbar-full p-0">
			<vs-navbar
				class="navbar-custom navbar-skelton"
				:class="navbarClasses"
				:style="navbarStyle"
				:color="navbarColor"
			>

				<!-- <bookmarks
					:navbarColor="navbarColor"
					v-if="windowWidth >= 992"
				/> -->

				<router-link
					tag="div"
					to="/"
					class="vx-logo cursor-pointer flex"
				>
					<logo class="w-10 mr-4 fill-current text-primary" />
					<!-- <span class="vx-logo-text text-primary">PannonHome</span> -->
				</router-link>

				<ul class="menu-items flex flex-wrap w-full items-center">
					<li
						class="menu-item"
						v-for="(item, index) in navMenuItems"
						:key="index"
						:class="{'mr-2': !(navMenuItems.length === index+1)}"
						v-if="!($store.state.AppActiveUser.userRole == 'worker' && item.onlyAdmin)"
					>
						<!-- If header -->
						<template v-if="item.header">
							<h-nav-menu-header
								:header="item"
								class="menu-header relative"
							/>
						</template>

						<!-- If it's group -->
						<template v-else-if="item.submenu">
							<h-nav-menu-group
								class="menu-group relative py-4"
								bottom
								:key="`group-${index}`"
								:group="item"
								:groupIndex="index"
								:open="checkGrpChildrenActive(item)"
							/>
						</template>
						<!-- If it's link -->
						<div
							v-else-if="item.url"
							class="menu-link"
						>
							<h-nav-menu-item
								class="relative py-4 cursor-pointer"
								:to="item.slug !== 'external' ? item.url : null"
								:href="item.slug === 'external' ? item.url : null"
								:icon="item.icon"
								:target="item.target"
								:isDisabled="item.isDisabled"
								:slug="item.slug"
							>
								<span class="truncate">{{  item.name }}</span>
								<vs-chip
									:color="item.tagColor"
									v-if="item.tag"
								>{{ item.tag }}</vs-chip>
							</h-nav-menu-item>
						</div>

					</li>
				</ul>

				<search-bar />

				<!-- <notification-drop-down /> -->

				<profile-drop-down />

			</vs-navbar>
		</div>
	</div>
</template>

<script>
import Bookmarks from "./components/Bookmarks.vue"
import SearchBar from "./components/SearchBar.vue"
import NotificationDropDown from "./components/NotificationDropDown.vue"
import ProfileDropDown from "./components/ProfileDropDown.vue"
import Logo from "../Logo.vue"
import HNavMenuGroup from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenuGroup.vue"
import HNavMenuHeader from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenuHeader.vue"
import HNavMenuItem from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenuItem.vue"

export default {
	name: "the-navbar-horizontal",
	props: {
		logo: { type: String },
		navbarType: {
			type: String,
			required: true,
		},
		navMenuItems: { type: Array, required: true },
	},
	components: {
		HNavMenuGroup,
		HNavMenuHeader,
		HNavMenuItem,
		Logo,
		Bookmarks,
		SearchBar,
		NotificationDropDown,
		ProfileDropDown,
	},
	methods: {
		checkGrpChildrenActive(group) {

			const path = this.$route.fullPath
			let active = false
			const routeParent = this.$route.meta ? this.$route.meta.parent : undefined

			if (group.submenu) {
				group.submenu.forEach((item) => {
					if ((path == item.url || routeParent == item.slug) && item.slug) { active = true }
					else if (item.submenu) { this.checkGrpChildrenActive(item) ? active = true : null }
				})
			}

			return active
		},
		hovered(val = true) {
			this.isHovered = val
			if (this.openOnHover) {
				val ? this.showChildren = true : this.showChildren = false
			}
		},
	},
	computed: {
		navbarColor() {
			let color = "#fff"
			if (this.navbarType === "sticky") color = "#f7f7f7"
			else if (this.navbarType === 'static') {
				if (this.scrollY < 50) {
					color = "#f7f7f7"
				}
			}

			this.isThemedark === "dark" ? color === "#fff" ? color = "#10163a" : color = "#262c49" : null

			return color
		},
		isThemedark() { return this.$store.state.theme },
		navbarStyle() { return this.navbarType === "static" ? { transition: "all .25s ease-in-out" } : {} },
		navbarClasses() { return this.scrollY > 5 && this.navbarType === "static" ? null : "d-theme-dark-light-bg shadow-none" },
		scrollY() { return this.$store.state.scrollY },
		verticalNavMenuWidth() { return this.$store.state.verticalNavMenuWidth },
		windowWidth() { return this.$store.state.windowWidth },
	}
}

</script>

